import { defineStore } from "pinia"
import { ref, computed } from "vue"
import { router } from "@/router"
import { axiosWrapper } from "@/utils/helpers/axios-wrapper"
import type { PersonalData } from "@/types/ClientType"

const baseUrl = `${import.meta.env.VITE_API_URL}`

export const useAuthStore = defineStore("auth", () => {
  // State
  // @ts-ignore
  const user = ref(JSON.parse(localStorage.getItem("user")))
  const bearerToken = ref(localStorage.getItem("bearerToken"))
  const returnUrl = ref<any>(null)

  // Actions
  function setReturnUrl(url: string) {
    returnUrl.value = url
  }

  async function login(email: string, password: string) {
    const auth = await axiosWrapper.post(`${baseUrl}/login`, { email, password })

    if (auth?.token) {
      bearerToken.value = auth.token
      localStorage.setItem("bearerToken", auth.token)
      await getUser()
    } else {
      console.error("login failed")
    }
  }

  async function getUser() {
    const userData = await axiosWrapper.get(`${baseUrl}/user`)
    if (userData) {
      user.value = userData

      localStorage.setItem("user", JSON.stringify(userData))
      router.push(returnUrl.value || "/dashboard")
      returnUrl.value = null
    } else {
      console.error("failed to get user")
      logout()
    }
  }

  async function saveUser(userData: PersonalData) {
    if (userData) {
      const response = await axiosWrapper.patch(`${baseUrl}/user`, userData)
      if (response) {
        localStorage.setItem("user", JSON.stringify(response))
      }
    }
  }

  function logout() {
    user.value = null
    bearerToken.value = null
    localStorage.removeItem("user")
    localStorage.removeItem("bearerToken")
    router.push("/auth/login")
  }

  // Getters
  const isAdmin = computed(() => user.value?.is_admin)
  const isServiceProvider = computed(() => user.value?.is_service_provider)
  const isClient = computed(() => user.value?.is_client)
  const fullName = computed(() => `${user.value?.personal_data?.first_name} ${user.value?.personal_data?.last_name}`)
  const roleText = computed(() => {
    if (user.value) {
      if (user.value?.is_admin) {
        return "Admin Coop"
      } else if (user.value?.is_service_provider) {
        return "Service Provider"
      } else {
        return "Client"
      }
    } else {
      return "-"
    }
  })

  return {
    // State
    user,
    bearerToken,
    returnUrl,
    // Actions
    setReturnUrl,
    login,
    getUser,
    saveUser,
    logout,
    // Getters
    isAdmin,
    isServiceProvider,
    isClient,
    fullName,
    roleText,
  }
})
